export default "__VITE_ASSET__D_Nb5PCV__"